module.exports = __webpack_public_path__ + "static/media/instagram.93f1d81c.jpg";